import React, { useEffect, useState } from "react";
import styled from "styled-components";
import UserLayout from "../../components/layouts/UserLayout";
import HeaderOne from "../../components/parts/HeaderOne";
import ShopList from "../../components/combinations/ShopList";
import CafeNoteList from "../../components/combinations/CafeNoteList";
import {
  GetCafeNotes200ResponseInner,
  GetPublicShops200ResponseInner,
} from "../../../api/v1";
import { api } from "../../../api";
import LinkButton from "../../components/parts/LinkButton";
import UserHead from "../../config/UserHead";

const FavoriteListStyle = styled.div`
  background: white;
  padding: 20px 0;
  margin-top: 50px;
`;

const CafeNoteListStyle = styled.div`
  background: white;
  padding: 20px 0;
`;

const HeaderOneStyle = styled(HeaderOne)`
  margin: 20px 30px;

  @media (max-width: 768px) {
    margin: 20px 10px;
  }
`;

const ListFooter = styled.div`
  text-align: center;
  margin-top: 20px;

  @media (max-width: 768px) {
    margin: 20px 10px 0 10px;
  }
`;

const ToListPageStyle = styled(LinkButton)`
  width: 400px;

  @media (max-width: 768px) {
    width: 150px;
  }
`;

const Dashboard: React.FC = () => {
  const [publicShops, setPublicShops] = useState<
    Array<GetPublicShops200ResponseInner>
  >([]);
  const [cafeNotes, setCafeNotes] = useState<
    Array<GetCafeNotes200ResponseInner>
  >([]);

  useEffect(() => {
    api.getPublicShops(1, 10, "", "", null, "", [], true).then((response) => {
      const shops = response.data;
      setPublicShops(shops);
    });
  }, []);

  useEffect(() => {
    api.getCafeNotes(1, 5).then((response) => {
      setCafeNotes(response.data);
    });
  }, []);

  return (
    <UserLayout>
      <UserHead title="ダッシュボード" />
      <CafeNoteListStyle>
        <HeaderOneStyle>カフェノート</HeaderOneStyle>
        <CafeNoteList cafeNotes={cafeNotes} />
        <ListFooter>
          <ToListPageStyle href="/user/cafe-notes">もっと見る</ToListPageStyle>
        </ListFooter>
      </CafeNoteListStyle>
      <FavoriteListStyle>
        <HeaderOneStyle>お気に入り</HeaderOneStyle>
        <ShopList shops={publicShops} />
        <ListFooter>
          <ToListPageStyle href={"/shops?favoriteFlag=true"}>
            もっと見る
          </ToListPageStyle>
        </ListFooter>
      </FavoriteListStyle>
      {/*<RequestShopListStyle>*/}
      {/*  <HeaderOne>申請店舗</HeaderOne>*/}
      {/*  <Divider mt='20px' mb='20px' />*/}
      {/*  <RequestShopCardList />*/}
      {/*  <ListFooter>*/}
      {/*    <ToListPageStyle href={'/user/request-shops'}>もっと見る</ToListPageStyle>*/}
      {/*  </ListFooter>*/}
      {/*</RequestShopListStyle>*/}
    </UserLayout>
  );
};
export default Dashboard;
